<template lang="pug">
.page 
    a-tabs
        a-tab-pane(key="news" tab="新闻内容")
            a-table(:columns="columns" 
                :pagination="{pageSize: 20}"
                :data-source="items" 
                size="small"
                row-key="_id")
                //- template(slot="title" slot-scope="text")
                //-     a {{text}}

                template(slot="assets" slot-scope="text, record")
                    div(v-for="i in text")
                        span {{i.asset}}
                        span(style="margin: 0 5px; font-size: 10px;") ({{i.category}})
                        a-tag(color="orange") {{i.emotion}}
                
                template(slot="expandedRowRender" slot-scope="record")
                    p(style="white-space: pre-wrap") {{record.summary}}
        a-tab-pane(key="count" tab="新闻统计")
            .ctl-bar
                a-range-picker(@change="onDateChange")
                a-button(@click="handleDownloadAna" style="margin-left: 10px" type="primary") 导出csv
            a-table(:columns="categoryCols"
                :pagination="{pageSize: 20}"
                :data-source="categoryItems" 
                size="small"
                row-key="category")
</template>

<script>

import moment from 'moment/moment';
import _ from 'lodash';

export default {
    data() {
        return {
            columns: [
                {
                    title: 'Title',
                    dataIndex: 'title',
                    key: 'title',
                    scopedSlots: {
                        customRender: 'title'
                    }
                },
                {
                    title: 'Date',
                    dataIndex: 'date',
                    key: 'date',
                },
                {
                    title: 'Assets',
                    dataIndex: 'assets',
                    key: 'assets',
                    scopedSlots: {
                        customRender: 'assets'
                    }
                }
            ],
            items: [],
            categoryCols: [
                {
                    title: '资产',
                    dataIndex: 'asset',
                    key: 'asset',
                }, 
                {
                    title: '正面',
                    dataIndex: '正面',
                    key: '正面',
                    sorter: (a, b) => a['正面'] - b['正面'],
                },
                {
                    title: '中性偏正面',
                    dataIndex: '中性偏正面',
                    key: '中性偏正面',
                    sorter: (a, b) => a['中性偏正面'] - b['中性偏正面'],
                },
                {
                    title: '中性',
                    dataIndex: '中性',
                    key: '中性',
                    sorter: (a, b) => a['中性'] - b['中性'],
                },
                {
                    title: '中性偏负面',
                    dataIndex: '中性偏负面',
                    key: '中性偏负面',
                    sorter: (a, b) => a['中性偏负面'] - b['中性偏负面'],
                },
                {
                    title: '负面',
                    dataIndex: '负面',
                    key: '负面',
                    sorter: (a, b) => a['负面'] - b['负面'],
                },
                
            ],
            categoryItems: [],
        }
    },  
    mounted() {
        this.getData();
    },
    methods: {
        handleDownloadAna() {
            let content = this.categoryItems.map(i => [i['asset'], i['正面'], i['中性偏正面'], i['中性'], i['中性偏负面'], i['负面']].join(',')).join('\n');
            content = 'asset,正面,中性偏正面,中性,中性偏负面,负面\n' + content;

            let blob = new Blob([content], {type: 'text/plain;charset=utf-8'});
            let url = URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download =  '新闻统计.csv';
            document.body.appendChild(a);
            a.click();

            setTimeout(() => {
                URL.revokeObjectURL(url);
            }, 100);
        },
        getData() {
            this.$api.request('GET', 'ftnews')
                .then(res => {
                    this.items = res.data.map(i => ({
                        ...i,
                        date: moment(i.Date).format('YYYY-MM-DD')
                    }))
                });
        },
        onDateChange(date, dateString) {
            let [start, end] = dateString;
            if (start) {
                this.getCategories(start, end);
            }
        },
        getCategories(start, end) {
            this.$api.request('GET', 'ftnews/assets', {
                    start, 
                    end,
                })
                .then(res => {
                    this.categoryItems = res.data;
                });
        }
    }


}
</script>